import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "h-full w-full flex flex-col gap-6 text-white"
};
const _hoisted_2 = {
  class: "flex items-center justify-between gap-3 border-b border-main-5/30 pb-4"
};
const _hoisted_3 = {
  class: "flex items-center gap-3"
};
const _hoisted_4 = {
  class: "flex items-center"
};
const _hoisted_5 = {
  key: 1,
  class: "flex flex-col gap-1.5 text-xs overflow-y-auto scroll pr-1 pb-6"
};
const _hoisted_6 = {
  key: 0,
  class: "h-10 rounded bg-white/10 skeleton-anim opacity-60"
};
const _hoisted_7 = {
  key: 1,
  class: "h-10 rounded bg-white/10 skeleton-anim opacity-60"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "flex items-center gap-3 grow"
};
const _hoisted_10 = {
  class: "text-main-60"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  class: "flex items-center gap-2 p-3 overflow-x-auto scroll-main"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = ["onClick"];
const _hoisted_16 = ["onClick"];
const _hoisted_17 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = _resolveComponent("Button");
  const _component_Collapsible = _resolveComponent("Collapsible");
  const _directive_ptooltip = _resolveDirective("ptooltip");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_3, [_createElementVNode("i", {
    class: "icon-previous text-xl cursor-pointer transition-transform hover:-translate-x-0.5",
    onClick: _cache[0] || (_cache[0] = (...args) => this.onclose && this.onclose(...args))
  }), _cache[4] || (_cache[4] = _createElementVNode("p", {
    class: "text-lg font-medium"
  }, "Configuración de empresas y grupos", -1))])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_Button, {
    variant: "outlined_light",
    size: "sm",
    text: "Nueva Empresa",
    icon: "icon-certificate",
    onClick: _cache[1] || (_cache[1] = $event => $props.viewConfig.openClientModal(false))
  })])]), !this.viewConfig.loading.clients && !$options.filteredClients.length ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "p-3 rounded flex items-center justify-center bg-white/10 border border-white/20 text-xs cursor-pointer",
    onClick: _cache[2] || (_cache[2] = $event => $props.viewConfig.openClientModal(false))
  }, " Todavía no tienes ninguna empresa registrada. ")) : (_openBlock(), _createElementBlock("div", _hoisted_5, [this.viewConfig.loading.clients ? (_openBlock(), _createElementBlock("div", _hoisted_6)) : _createCommentVNode("", true), this.viewConfig.loading.clients ? (_openBlock(), _createElementBlock("div", _hoisted_7)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredClients, company => {
    return _openBlock(), _createElementBlock("div", {
      key: company,
      class: "w-full bg-main-10 rounded-md"
    }, [_createElementVNode("div", {
      class: "group h-12 flex items-center bg-main-5 text-main-100 rounded-md shadow-weak_material cursor-pointer *:px-5",
      onClick: $event => company.open = !company.open
    }, [_createElementVNode("p", _hoisted_9, [_cache[5] || (_cache[5] = _createElementVNode("i", {
      class: "icon-certificate text-xl"
    }, null, -1)), _createElementVNode("span", null, _toDisplayString(company.fieldsValues.nombreEmpresa), 1), _cache[6] || (_cache[6] = _createTextVNode(" • ")), _createElementVNode("span", _hoisted_10, _toDisplayString($options.FilterCompanyGroups(company.groups)?.length) + " grupo/s creados", 1)]), _createElementVNode("div", {
      class: "group-hover:opacity-100 opacity-0 flex items-center gap-3 transition-opacity",
      onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
    }, [_withDirectives(_createElementVNode("i", {
      class: "icon-edit text-lg opacity-70 hover:opacity-100 transition-opacity",
      onClick: $event => $props.viewConfig.openClientModal(true, company)
    }, null, 8, _hoisted_11), [[_directive_ptooltip, 'Editar']]), _withDirectives(_createElementVNode("i", {
      class: "icon-trash text-lg opacity-70 hover:opacity-100 transition-opacity",
      onClick: $event => $options.RemoveClient(company)
    }, null, 8, _hoisted_12), [[_directive_ptooltip, 'Eliminar']]), _createVNode(_component_Button, {
      variant: "tinted",
      size: "xs",
      text: "Enviar Email",
      onClick: $event => this.SendEmail(company)
    }, null, 8, ["onClick"])])], 8, _hoisted_8), _createVNode(_component_Collapsible, {
      collapsed: !company.open
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", {
        class: "flex items-center gap-2 py-2 px-4 border border-dashed border-second-100 text-second-100 bg-second-5 hover:bg-second-10 cursor-pointer rounded transition-colors whitespace-nowrap",
        onClick: $event => $props.viewConfig.openGroupModal(false, company)
      }, _cache[7] || (_cache[7] = [_createTextVNode(" Nuevo grupo "), _createElementVNode("i", {
        class: "icon-user text-xs"
      }, null, -1)]), 8, _hoisted_14), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.FilterCompanyGroups(company.groups), group => {
        return _openBlock(), _createElementBlock("div", {
          key: group,
          class: _normalizeClass(["group w-fit flex items-center py-2 px-4 bg-second-75 rounded text-main-5 shadow-weak_material cursor-pointer hover:bg-second-100 transition-colors whitespace-nowrap", {
            'bg-cta-100!': group.selected
          }]),
          onClick: $event => group.selected = !group.selected
        }, [_createTextVNode(_toDisplayString(group.text) + " ", 1), _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "w-0 opacity-0 group-hover:w-6 group-hover:opacity-100 flex justify-end transition-[width,opacity]",
          onClick: _withModifiers($event => $props.viewConfig.openGroupModal(true, company, group.key, group.text), ["stop"])
        }, _cache[8] || (_cache[8] = [_createElementVNode("i", {
          class: "icon-edit hidden group-hover:flex text-sm cursor-pointer hover:underline"
        }, null, -1)]), 8, _hoisted_16)), [[_directive_ptooltip, 'Editar']]), _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "w-0 opacity-0 group-hover:w-6 group-hover:opacity-100 flex justify-end transition-[width,opacity]",
          onClick: _withModifiers($event => $props.viewConfig.copyGroup(company, group.key, group.text), ["stop"])
        }, _cache[9] || (_cache[9] = [_createElementVNode("i", {
          class: "icon-copy hidden group-hover:flex text-sm cursor-pointer hover:underline"
        }, null, -1)]), 8, _hoisted_17)), [[_directive_ptooltip, 'Copiar']])], 10, _hoisted_15);
      }), 128)), company.groups?.filter(g => g.selected)?.length ? (_openBlock(), _createBlock(_component_Button, {
        key: 0,
        variant: "outlined",
        size: "xs",
        text: 'Eliminar grupos seleccionados',
        icon: "icon-trash",
        class: "ml-auto",
        onClick: $event => $options.RemoveGroups(company.groups?.filter(g => g.selected), company)
      }, null, 8, ["onClick"])) : _createCommentVNode("", true)])]),
      _: 2
    }, 1032, ["collapsed"])]);
  }), 128))]))]);
}